(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Settings",
                    {
                        url: "/Settings",
                        component: "mtsettings",
                        PageTitle: "Settings | Marketing Tracker",
                        redirectTo: "Home.Tools.MarketingTrackerNew.Settings.SalesTrackerSettings"
                    });
        }
    ]);

    app.component("mtsettings",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/Settings/settings-template.html",
            controller: mtsettingsController,
            bindings: {
                user: "<",
                onBehalfOfUser: "<"
            }
        });

    mtsettingsController.$inject = [];
    function mtsettingsController() {

        var $ctrl = this;
    }
})(window.app, window.angular); //jshint ignore:line